import { ReactNode, useEffect } from 'react';

import { LOCALE_LSK } from '@app/config/localstorage-keys.const';
import { useCpmsBoGetMeQuery } from '@service/cpms-bo-user-me.service';

import i18n from './i18n';

export const LanguageInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { data: user, isSuccess } = useCpmsBoGetMeQuery();

  useEffect(() => {
    if (isSuccess && user?.language) {
      i18n.changeLanguage(user.language);
      localStorage.setItem(LOCALE_LSK, user.language);
    }
  }, [isSuccess, user]);

  return children;
};
